import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseFormComponent } from '../../../shared/class/base-form.class';
import { GENDER } from '../../../shared/constansts/app.const';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { Organization } from '../../../shared/models/Organization.model';
import { Role } from '../../../shared/models/role.model';
import { removeFalsyValues } from '../../../shared/utils/functions/util-functions';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent extends BaseFormComponent implements OnInit {
  addUserForm: FormGroup;
  genderOptions = GENDER;
  date: Date | undefined;
  organizationOptions: any = [];

  roleOptions: any = []

  constructor(protected override fb: FormBuilder) {
    super();
    this.addUserForm = this.fb.group({
      firstName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(40),
        Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$') // Fixed the regex pattern
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(40),
        Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$') // Fixed the regex pattern
      ]),
      email: new FormControl('', [Validators.required, Validators.email]),
      mobile: new FormControl('', [
        Validators.pattern(/^\d{6,10}$/),
        Validators.minLength(6),
        Validators.maxLength(10),
        Validators.required
      ]),
      gender: new FormControl('' ,[Validators.required]),
      dob: new FormControl(''),
      organization: new FormControl('', [Validators.required]),
      roles: new FormControl('',[Validators.required]),
      gstInNumber: new FormControl(''),
      orgName: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.getUserRole();
    this.getOrganization();
  }

  async submitForm(){

    if(this.addUserForm.valid){
      let response:ApiResponse<any> = await this.httpService.httpRequest<any>(
        "user",
        "find-all-and-count-by-admin",
      this.addUserForm.value,

       );
    }
  }


  async getUserRole(){

    let response:ApiResponse<[Role[], number]> = await this.httpService.httpRequest<[Role[], number]>(
      "role",
      "find-all-and-count-by-admin",
     );
     if(response.status && response.data){
     this.roleOptions =response.data[0];
     }
  }



  async getOrganization(){
    let response: ApiResponse<[Organization[], number]> =
    await this.httpService.httpRequest<[Organization[], number]>(
      "organization",
      "find-all-and-count-by-admin"
    )
    if(response.status && response.data){
      this.organizationOptions =response.data[0];
      }
  }

  async addUser(){
    this.isSubmitted.set(true);
    if(this.addUserForm.valid){
      let payload= removeFalsyValues(this.addUserForm.value);
      payload = {
        ...payload,
        organization:{
          id: payload.organization
        },
        roles: payload.roles.map((r:number) => ({id: r}))
      }
       let response:ApiResponse<any> = await this.httpService.httpRequest<any>(
         "user",
         "create-user",
         payload
        );
        if(response.status && response.data){
       this.notificationService.showSuccess(response.message);
       this.addUserForm.reset();
       this.isSubmitted.set(false);
       this.router.navigateByUrl("/settings/users");
        }else{
         this.notificationService.showError(response.message);
        }
    }



  }


}
